import { render, staticRenderFns } from "./Comp50t2.vue?vue&type=template&id=74ac87fc&scoped=true&"
import script from "./Comp50t2.vue?vue&type=script&lang=js&"
export * from "./Comp50t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp50t2.vue?vue&type=style&index=0&id=74ac87fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac87fc",
  null
  
)

export default component.exports